<template>
  <div class="ibox-child one-child">
    <div class="child-tools">
      <span class="info-menu">
        <h4 class="h4"><img class="one-icon" src="static/img/assets/nav_1on1_on.png" alt="">1on1</h4>
      </span>
      <span class="info-time">
        <span>{{ item.createdAt | preparedTime }}</span>
      </span>
    </div>
    <div class="history-item">
      <span>
        <span>{{ getUserInfoById(item.userId).userName }}</span>{{$t('sendOneOnRequestMsgString')}}
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  name: 'OneSentItem',
  props: ['item'],
  components: {
  },
  data: function () {
    return {
      view: this.view
    }
  },
  computed: {
    ...mapGetters([
      'getUserInfoById'
    ])
  },
  filters: {
    preparedTime: function (date) {
      return moment(date * 1000).format('YYYY/MM/DD HH:mm')
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/One/OneSentItem.vue